import React from 'react';
import { connect } from 'react-redux';
import LocationCard from '../LocationCard';
import MapOld from '../../../../../components/Map_old';
import './LocationDropDown.scss';
import '../SubHeader.scss';
import CircleGraph from '../../../../../components/graphics/CircleGraph';
import FavoritesStarIcon from '../../../../../components/Iconoclast/FavoritesStarIcon';

import BaseComponent from '../../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure

class LocationDropDown extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: this.props.project ? this.props.project.location : null, 
      displayMap: true, zoom: 12,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.location) {
      this.setState({ location: this.props.location });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location != this.props.location || prevProps.project != this.props.project) {
      if (this.props.location) {
        this.setState({ location: this.props.location });
      }
    }
  }

  handleShowMapContent(e) {
    let zoom = null;
    if (this.state.zoom < 17 || !this.state.zoom) {
      zoom = 17;
    }
    else if (this.state.zoom == 17) {
      zoom = 12;
    }
    if (this.state.center && (e.latitude != this.state.center.latitude || e.longitude != this.state.center.longitude) && zoom == 12) {
      const self = this;
      setTimeout(() => {
        self.setState({ zoom: 17, center: { latitude: parseFloat(e.latitude), longitude: parseFloat(e.longitude) } });
      }, 20);
    }
    this.setState({ zoom: zoom, center: { latitude: parseFloat(e.latitude), longitude: parseFloat(e.longitude) } });
  }

  handleZoom(zoom) {
    this.setState({ zoom: zoom });
  }

  handleLocationSelection(location) {
    if (this.props.allProjects || this.props.all_locations) {
      this.handleShowMapContent({ latitude: location.latitude, longitude: location.longitude });
    }
    else {
      this.setState({ selectedLocation: location, displayMap: !this.state.displayMap });
    }
  }

  handleClose() {
    const { handleCloseDropDown } = this.props;
    if (handleCloseDropDown) {
      handleCloseDropDown();
    }
  }

  render() {
    const { project, all_locations, company, changedLocation, height } = this.props;
    const { location, displayMap } = this.state;
    let fullWidth = true;

    if (!all_locations && !this.props.allProjects && project && project.location && !this.state.selectedLocation) {
      this.state.selectedLocation = project.location;
    }
    if (!all_locations && !this.props.allProjects && location && !this.state.selectedLocation){
      this.state.selectedLocation = location;
    }
    if (!all_locations && !this.props.allProjects && changedLocation && changedLocation != this.changedLocation) {
      this.state.selectedLocation = changedLocation;
      this.changedLocation = changedLocation;
    }

    const filteredCustomSettings = project && project.custom_project_settings ? project.custom_project_settings.filter(cps => {
      return true;
    }) : [];
    const customSettingsList = filteredCustomSettings.map(customSetting => {
      let settingValue = null;
      let minValue = 0;
      let maxValue = 0;
      switch (customSetting.setting_type) {
      case 1:
        settingValue = customSetting.text_value + (customSetting.units ? ' ' + customSetting.units : '');
        break;
      case 2:
        settingValue = customSetting.float_value + (customSetting.units ? ' ' + customSetting.units : '');
        break;
      case 3:
        if (customSetting.min_value && customSetting.max_value) {
          minValue = customSetting.min_value;
          maxValue = customSetting.max_value;
          settingValue = customSetting.integer_value;
        }
        else {
          settingValue = customSetting.integer_value + (customSetting.units ? ' ' + customSetting.units : '');
        }

        break;
      case 4:
        settingValue = customSetting.boolean_value ? 'Yes' : 'No';
        break;
      case 5:
        settingValue = customSetting.text_value;
        break;
      default:
        break;
      }
      if (minValue && maxValue) {
        const position = Math.floor(200 * ((settingValue - minValue) / (maxValue - minValue)));
        return <div key={customSetting.id} className="project-setting">
          <div className="project-setting-label">{customSetting.setting_label ? customSetting.setting_label : 'Project Custom Field'}</div>
          <div className="project-setting-scale">
            <div className="outer-scale" style={{ width: 200 }}>
              <div className="inner-scale" style={{ width: position }}/>
            </div>
          </div>
        </div>;
      }
      else {
        return <div key={customSetting.id} className="project-setting">
          <div className="project-setting-label">{customSetting.setting_label ? customSetting.setting_label : 'Project Custom Field'}</div>
          <div className="project-setting-value">{settingValue}</div>
        </div>;
      }
    });

    const { selectedLocation } = this.state;
    let mapContents = null;
    if (this.props.company && this.props.company.latitude && this.props.company.longitude) {
      mapContents = [{
        id: 2,
        address: this.props.company.address_1, city: this.props.company.city,
        state: this.props.company.state, zip: this.props.company.zip,
        latitude: this.props.company.latitude, longitude: this.props.company.longitude,
      }];
    }
    else if (all_locations) {
      let idList = [];
      mapContents = all_locations.map((location, index) => { 
        let found = false;
        for (let i = 0; i < idList.length; i++){
          if (idList[i] == location.id) {
            idList[i] = location.id;
            found = true;
            break;
          } 
        }
        if (!found && location) {
          return {
            id: index,
            address: location.address, city: location.city,
            state: location.state, zip: location.zip,
            latitude: location.latitude, longitude: location.longitude,
          };
        }
        else{
          return null;
        }
      }).filter(mc => { return mc != null; });
    }
    else if (!selectedLocation && project && project.location && project.location.latitude && project.location.longitude) {
      mapContents = [{
        id: 1,
        address: this.props.project.location.address, city: this.props.project.location.city,
        state: this.props.project.location.state, zip: this.props.project.location.zip,
        latitude: this.props.project.location.latitude, longitude: this.props.project.location.longitude,
      }];
    }
    else if (selectedLocation && selectedLocation.latitude && selectedLocation.longitude) {
      mapContents = [{
        id: 1,
        address: selectedLocation.address, city: selectedLocation.city,
        state: selectedLocation.state, zip: selectedLocation.zip,
        latitude: selectedLocation.latitude, longitude: selectedLocation.longitude,
      }];
    }
    else if (this.props.allProjects && this.props.myProjects) {
      let idList = [];
      mapContents = (!this.props.myProjects || !this.props.myProjects.projects) ? [] : this.props.myProjects.projects.map((project, index) => { 
        let found = false;
        for (let i = 0; i < idList.length; i++){
          if (idList[i] == project.location.id) {
            idList[i] = project.location.id;
            found = true;
            break;
          } 
        }
        if (!found && project.location) {
          return {
            id: index,
            address: project.location.address, city: project.location.city,
            state: project.location.state, zip: project.location.zip,
            latitude: project.location.latitude, longitude: project.location.longitude,
          };
        }
        else{
          return null;
        }
      }).filter(mc => { return mc != null; });
    }  
    else {
      // return null
    }

    let style = {};
    if (height) {
      style.height = height;
    }

    let projectNotes = null;
    if (project && project.notes) {
      projectNotes = <div className="project-notes">
        <div className='label'>Project Notes</div>
        <div className='notes'>{project.notes}</div>
      </div>;
    }

    let rightSide;
    let leftSide;
    if (displayMap) {
      if(!mapContents || mapContents.length == 0 || (mapContents.length == 1 && mapContents[0].latitude == null && mapContents[0].longitude == null)){
        rightSide = <div className="right-column full-width">
          <div className="location-snapshot">
            <div className="overlay" />
            <div className='location-details'>
              <div className="location-name">No Location</div>
            </div>
          </div>
        </div>;
      }
      else {
        rightSide = 
        <div className={'right-column' + (company ? ' full-width' : '')}>
          <MapOld 
            contents={mapContents} 
            onShowContent={this.handleShowMapContent} 
            center={this.state.center}
            zoom={this.state.zoom} 
            handleZoom={this.handleZoom}
            projects={[project]}
          />
        </div>;
      }
    }
    if (all_locations) {
      let locationsList = null;
    
      let locationCards;
      if (all_locations.length > 0) {
        locationCards = all_locations.map(location => {
          const selected = this.state.zoom == 17 && this.state.center && this.state.center.longitude == location.longitude && this.state.center.latitude == location.latitude;
          return <LocationCard key={location.id} location={location} company={this.props.company} handleLocationSelection={this.handleLocationSelection}
            isSelectedLocation={selected} fullAddress={true} />;
        });
        locationsList = <div className="locations-list-container">
          {locationCards}
        </div>;
      }
      else {
        rightSide = <div className="right-column full-width">
          <div className="location-snapshot">
            <div className="overlay" />
            <div className='location-details'>
              <div className="location-name">No Locations</div>
            </div>
          </div>
        </div>;
        fullWidth = false;
      }
      if(fullWidth){
        leftSide = <div className="left-column">
          <hr className="dividing-line" />
          <div className="locations-list">
            {locationsList}  
          </div>
          <hr className="dividing-line" />
          {projectNotes}
          <hr className="dividing-line" />
          <div className="project-settings-list">
            {customSettingsList}
          </div>
        </div>;
      }
      if (!displayMap) {
        const cityState = project.location ? project.location.city + ', ' + project.location.state : null;
        let percent = 0.0;
        let stringPercent = '0.0%';
        percent = project.tasks_completed_count / project.tasks_count;
        stringPercent = project.tasks_count ? Math.floor(project.tasks_completed_count * 100 / project.tasks_count) + '%' : '0%';
        let graphColor = '#CD030A';

        const favoriteIndicator = project.is_favorite ? <div className="favorite-indicator" onClick={this.handleFavorites}>
          <FavoritesStarIcon fillColor={project.is_favorite ? '#F5A623' : null} />
        </div> : null;

        rightSide = <div className="right-column">
          <div className="project-snapshot">
            <div className="overlay" />
            <div className="top-two-third">
              <div className="progress-circle">
                <CircleGraph width={119} height={119} left={0} top={0} strokeWidth={5} position="absolute" color={graphColor}
                  percent={percent} />
                <div className="percent">
                  {stringPercent}
                </div>
              </div>
            </div>
            <div className="bottom-third">
              <div className="project-city-state">{cityState}</div>
              <div className="project-title">{project.name}</div>
              {favoriteIndicator}
            </div>
          </div>
        </div>;
      }    }
    else if (project || this.props.allProjects) {
      let locationsList = null;
      if (project && !this.props.allProjects) {
        locationsList = <div className="locations-list-container">
          <LocationCard location={project ? project.location : null} company={this.props.company} handleLocationSelection={this.handleLocationSelection}
            isSelectedLocation={displayMap} fullAddress={true} />
        </div>;
        if (!project.location || !project.location.latitude || !project.location.longitude) {
          fullWidth = false;
        }
      }
      else {
        let uniqueLocations = [];
        let projects = this.props.locationProjects ? this.props.locationProjects : this.props.myProjects;
        if (this.props.locationProjects) {
          projects = this.props.locationProjects;
        }
        else if (this.props.myProjects){
          projects = this.props.myProjects.projects;
        }
        if (!projects) {
          return null;
        }
        projects.filter(project => {
          if (project.location) {
            const exists = uniqueLocations.filter(location => {
              return location.id == project.location.id;
            });
            if (exists.length == 0) {
              uniqueLocations.push(project.location);
            }
          }
          return true;
        });
        let locationCards;
        if(uniqueLocations.length > 0){
          locationCards = uniqueLocations.map(location => {
            const selected = this.state.zoom == 17 && this.state.center && this.state.center.longitude == location.longitude && this.state.center.latitude == location.latitude;
            return <LocationCard key={location.id} location={location} company={this.props.company} handleLocationSelection={this.handleLocationSelection}
              isSelectedLocation={selected} fullAddress={true}/>;
          });
          locationsList = <div className="locations-list-container">
            {locationCards}  
          </div>;
        }
        else{
          rightSide = <div className="right-column full-width">
          <div className="location-snapshot">
            <div className="overlay" />
            <div className='location-details'>
              <div className="location-name">No Locations</div>
            </div>
          </div>
        </div>;
          fullWidth = false;
        } 
      }
      if(fullWidth){
        leftSide = <div className="left-column">
          <hr className="dividing-line" />
          <div className="locations-list">
            {locationsList}  
          </div>
          <hr className="dividing-line" />
          {projectNotes}
          <hr className="dividing-line" />
          <div className="project-settings-list">
            {customSettingsList}
          </div>
        </div>;
      }
      if (!displayMap) {
        const cityState = project.location ? project.location.city + ', ' + project.location.state : null;
        let percent = 0.0;
        let stringPercent = '0.0%';
        percent = project.tasks_completed_count / project.tasks_count;
        stringPercent = project.tasks_count ? Math.floor(project.tasks_completed_count * 100 / project.tasks_count) + '%' : '0%';
        let graphColor = '#CD030A';

        const favoriteIndicator = project.is_favorite ? <div className="favorite-indicator" onClick={this.handleFavorites}>
          <FavoritesStarIcon fillColor={project.is_favorite ? '#F5A623' : null} />
        </div> : null;

        rightSide = <div className="right-column">
          <div className="project-snapshot">
            <div className="overlay" />
            <div className="top-two-third">
              <div className="progress-circle">
                <CircleGraph width={119} height={119} left={0} top={0} strokeWidth={5} position="absolute" color={graphColor}
                  percent={percent} />
                <div className="percent">
                  {stringPercent}
                </div>
              </div>
            </div>
            <div className="bottom-third">
              <div className="project-city-state">{cityState}</div>
              <div className="project-title">{project.name}</div>
              {favoriteIndicator}
            </div>
          </div>
        </div>;
      }
    }
    if(!all_locations && location && mapContents && mapContents.length > 0){
      leftSide = <div className="left-column">
        <hr className="dividing-line" />
        <div className="locations-list">
          <div className="locations-list-container">
            <LocationCard location={location} company={this.props.company} handleLocationSelection={this.handleLocationSelection}
              isSelectedLocation={displayMap} fullAddress={true} />
          </div>
        </div>
        <hr className="dividing-line" />
        {projectNotes}
        <hr className="dividing-line" />
        <div className="project-settings-list">
          {customSettingsList}
        </div>
      </div>;
      if(!displayMap){
        let city = location.city ? location.city : '';
        let state = location.state ? location.state : '';
        let locationCityState = city != '' && state != '' ? `${city}, ${state}` : ''; 
        rightSide = <div className="right-column">
          <div className="location-snapshot">
            <div className="overlay" />
            <div className='location-details'>
              <div className="location-name">{location.name}</div>
              <div className="location-guid">ID: {location.guid}</div>
              <div className='location-address'>{location.address}</div>
              <div className="location-city-state">{locationCityState}</div>
              <div className="location-lat-long">{`[${location.latitude}] [${location.longitude}]`}</div>
            </div>
          </div>
        </div>;
      }
    }

    return (
      <div id="mapDisplay" className="map-container dropdown-container" style={style}>
        <div className="close-button" onClick={this.handleClose}>
        </div>
        {leftSide}
        {rightSide}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(LocationDropDown);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/SubHeader/LocationDropDown/index.js